<template>
  <svg width="100%" height="100%" viewBox="551 721 216 219">
    <defs>
      <radialGradient
        id="radialGradient-1"
        cx="52.6975959%"
        cy="15.4758772%"
        fx="52.6975959%"
        fy="15.4758772%"
        r="54.058955%"
      >
        <stop offset="32.89%" />
        <stop offset="56.64%" />
        <stop offset="67.45%" />
        <stop offset="75.64%" />
        <stop offset="82.51%" />
        <stop offset="88.55%" />
        <stop offset="94.01%" />
        <stop offset="98.92%" />
        <stop offset="100%" />
      </radialGradient>
    </defs>
    <g
      id="Group"
      stroke="none"
      fill="none"
      transform="translate(551.000000, 721.000000)"
    >
      <path
        id="Shape"
        d="M192.261386,22.8879699 C181.033663,20.4180451 142.752475,7.82142857 138.90297,5.92781955 C118.158416,1.97593985 97.4138614,1.97593985 76.6693069,5.92781955 C72.819802,7.73909774 34.5386139,20.4180451 23.3108911,22.8879699 C11.1207921,25.5225564 1.71089109,34.9906015 0.213861386,81.5898496 C-1.44217971e-13,89.1642857 33.3623762,92.2928571 39.1366337,86.6943609 C41.0613861,76.4030075 42.4514851,75.9090226 44.0554455,69.6518797 C44.2693069,114.028195 44.4831683,179.15188 43.4138614,203.439474 C43.0930693,211.754887 65.9762376,218.341353 101.156436,218.341353 L114.09505,218.341353 C149.275248,218.341353 172.265347,211.672556 171.837624,203.439474 C170.768317,179.15188 170.982178,114.028195 171.19604,69.6518797 C172.906931,75.9090226 174.29703,76.4030075 176.114851,86.6943609 C181.889109,92.2928571 215.251485,89.1642857 215.037624,81.5898496 C213.861386,34.9082707 204.451485,25.5225564 192.261386,22.8879699 Z"
        :fill="secondaryColor"
      />
      <g
        id="Shape"
        transform="translate(39.564356, 16.466165)"
        :fill="primaryColor"
      >
        <path
          d="M1.28316832,28.568797 C3.42178218,32.5206767 4.7049505,36.7195489 5.23960396,40.6714286 C47.049505,44.9526316 89.5009901,44.9526316 131.310891,40.6714286 C131.845545,36.7195489 133.128713,32.5206767 135.267327,28.568797 C90.7841584,33.343985 45.6594059,33.343985 1.28316832,28.568797 Z"
        />
        <path
          d="M4.5980198,57.7139098 C4.5980198,61.5011278 4.5980198,65.4530075 4.7049505,69.4048872 C46.8356436,73.6860902 89.6079208,73.6860902 131.845545,69.4048872 C131.845545,65.3706767 131.845545,61.5011278 131.952475,57.7139098 C89.6079208,62.0774436 46.8356436,62.0774436 4.5980198,57.7139098 Z"
        />
        <path
          d="M4.7049505,155.769925 C46.9425743,160.051128 89.7148515,160.051128 131.845545,155.769925 C131.845545,151.982707 131.738614,148.113158 131.738614,144.078947 C89.6079208,148.36015 46.9425743,148.36015 4.7049505,144.078947 L4.7049505,155.769925 Z"
        />
        <path
          d="M4.81188119,115.263158 L4.81188119,126.954135 C46.9425743,131.235338 89.6079208,131.235338 131.738614,126.954135 L131.738614,115.263158 C89.6079208,119.544361 46.9425743,119.544361 4.81188119,115.263158 Z"
        />
        <path
          d="M131.738614,86.5296992 C89.6079208,90.8109023 46.9425743,90.8109023 4.81188119,86.5296992 L4.81188119,98.2206767 C46.9425743,102.50188 89.6079208,102.50188 131.738614,98.2206767 L131.738614,86.5296992 Z"
        />
        <path
          d="M0.213861386,67.0996241 L0.213861386,67.0996241 C1.28316832,62.1597744 2.24554455,60.0191729 3.1009901,57.5492481 L3.1009901,57.5492481 C2.24554455,60.0191729 1.28316832,62.1597744 0.213861386,67.0996241 Z"
        />
        <path
          d="M133.342574,57.5492481 L133.342574,57.5492481 C134.30495,60.0191729 135.160396,62.1597744 136.229703,67.0996241 L136.229703,67.0996241 C135.160396,62.1597744 134.19802,60.0191729 133.342574,57.5492481 Z"
        />
        <path
          d="M4.38415842,172.812406 C4.27722772,177.258271 4.17029703,181.12782 4.06336634,184.503383 C46.6217822,188.866917 89.7148515,188.866917 132.273267,184.503383 C132.166337,181.21015 132.059406,177.258271 131.952475,172.812406 C89.7148515,177.17594 46.7287129,177.17594 4.38415842,172.812406 Z"
        />
        <path
          d="M5.02574257,11.9379699 C46.9425743,16.2191729 89.3940594,16.2191729 131.310891,11.9379699 C126.49901,8.48007519 119.441584,5.10451128 111.10099,1.97593985 C82.550495,3.9518797 53.7861386,3.9518797 25.2356436,1.97593985 C16.8950495,5.10451128 9.94455446,8.48007519 5.02574257,11.9379699 Z"
        />
        <path
          d="M136.229703,1.8112782 C134.625743,1.31729323 132.914851,0.823308271 131.20396,0.246992481 L131.20396,0.246992481 C132.914851,0.740977444 134.625743,1.31729323 136.229703,1.8112782 Z"
        />
        <path
          d="M5.23960396,0.246992481 L5.23960396,0.246992481 C3.52871287,0.740977444 1.92475248,1.31729323 0.213861386,1.8112782 C1.92475248,1.31729323 3.52871287,0.740977444 5.23960396,0.246992481 Z"
        />
      </g>
      <g
        id="Shape"
        transform="translate(0.000000, 3.293233)"
        :fill="primaryColor"
      >
        <path
          d="M192.261386,19.5947368 C181.033663,17.124812 142.752475,4.52819549 138.90297,2.63458647 C132.059406,1.31729323 125.108911,0.411654135 118.265347,-1.13686838e-13 C118.158416,3.29323308 121.045545,6.25714286 128.851485,8.31541353 C160.182178,16.4661654 183.920792,28.7334586 176.970297,38.2838346 C170.019802,47.8342105 169.592079,60.0191729 171.516832,66.2763158 L171.516832,66.6056391 C173.120792,72.6157895 174.510891,73.1921053 176.435644,83.4011278 C182.209901,88.9996241 215.572277,85.8710526 215.358416,78.2966165 C213.861386,31.6150376 204.451485,22.2293233 192.261386,19.5947368 Z"
        />
        <path
          d="M23.3108911,19.5947368 C11.1207921,22.2293233 1.71089109,31.6973684 0.213861386,78.2966165 C-1.44217971e-13,85.8710526 33.3623762,88.9996241 39.1366337,83.4011278 C41.0613861,73.2744361 42.3445545,72.6157895 44.0554455,66.6056391 L44.0554455,66.2763158 C45.980198,60.0191729 45.4455446,47.8342105 38.6019802,38.2838346 C31.6514851,28.7334586 55.390099,16.4661654 86.7207921,8.31541353 C94.6336634,6.25714286 97.4138614,3.29323308 97.3069307,0 C90.4633663,0.411654135 83.5128713,1.31729323 76.6693069,2.63458647 C72.9267327,4.44586466 34.5386139,17.124812 23.3108911,19.5947368 Z"
        />
      </g>
      <g id="Shape" transform="translate(74.851485, 0.000000)">
        <path
          d="M32.9346535,26.4281955 C13.7940594,26.4281955 1.71089109,14.4902256 0.320792079,6.91578947 C0.106930693,5.68082707 2.67326733,5.18684211 4.5980198,3.29323308 C6.41584158,1.56428571 17.3227723,0.493984962 32.9346535,0.493984962 C48.5465347,0.493984962 59.4534653,1.56428571 61.2712871,3.29323308 C63.3029703,5.18684211 65.7623762,5.76315789 65.5485149,6.91578947 C64.1584158,14.4078947 52.0752475,26.4281955 32.9346535,26.4281955 Z"
          :fill="secondaryColor"
        />
        <path
          d="M0.534653465,7.73909774 C21.9207921,4.44586466 43.9485149,4.44586466 65.3346535,7.73909774 C65.4415842,7.49210526 65.4415842,7.16278195 65.5485149,6.91578947 C65.7623762,5.68082707 63.1960396,5.18684211 61.2712871,3.29323308 C59.4534653,1.56428571 48.5465347,0.493984962 32.9346535,0.493984962 C17.3227723,0.493984962 6.41584158,1.56428571 4.5980198,3.29323308 C2.56633663,5.18684211 0.106930693,5.76315789 0.320792079,6.91578947 C0.427722772,7.16278195 0.427722772,7.49210526 0.534653465,7.73909774 Z"
          :fill="primaryColor"
        />
        <path
          d="M61.3782178,3.37556391 C63.409901,13.9962406 44.3762376,22.8056391 34.8594059,22.8056391 L31.2237624,22.8056391 C21.7069307,22.8056391 2.56633663,13.9962406 4.7049505,3.37556391 C2.78019802,5.18684211 0.320792079,5.76315789 0.534653465,6.91578947 C1.92475248,14.4078947 14.0079208,26.4281955 33.1485149,26.4281955 C52.2891089,26.4281955 64.3722772,14.4902256 65.7623762,6.91578947 C65.7623762,5.68082707 63.3029703,5.18684211 61.3782178,3.37556391 Z"
          :fill="primaryColor"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HorizontalStripesJersey ',
  props: {
    primaryColor: {
      type: String,
      required: false,
      default: '#00A82D',
    },
    secondaryColor: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
  },
}
</script>
